var _$formatStyle_8 = function (r) {
  var n = "";

  for (var o in r) n += `${o}: ${r[o].toString()}; `;

  return n;
};

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImZvcm1hdFN0eWxlLmpzIl0sIm5hbWVzIjpbIm1vZHVsZSIsInByb3BzIiwicyIsImtleSIsInRvU3RyaW5nIl0sIm1hcHBpbmdzIjoiQUFBQUEsbUJBQUFBLEdBQWlCLFVBQVNDLENBQVQsRUFBU0E7RUFDeEIsSUFBSUMsQ0FBQUEsR0FBSSxFQUFSLENBQUE7O0VBRUEsS0FBSyxJQUFJQyxDQUFULElBQWdCRixDQUFoQixFQUNFQyxDQUFBQSxJQUFBQSxDQUFBQSxFQUFRQyxDQUFBQSxDQUFBQSxFQUFBQSxFQUFRRixDQUFBQSxDQUFNRSxDQUFORixDQUFBQSxDQUFXRyxRQUFYSCxFQUFXRyxDQUFBQSxFQUFBQSxDQUEzQkYsQ0FBQUE7O0VBR0YsT0FBT0EsQ0FBUCxDQUFBO0NBUEZGLENBQUFBIiwic291cmNlc0NvbnRlbnQiOltudWxsXX0=